import styles from './product-structure.module.scss';
import { Col, Row } from 'reactstrap';
import PageTitle from '../../page-title/page-title';
import { Box, Container } from '@frontend-workspace/react-shared-lib';
import ProductStructureGrid from '../product-structure-grid/product-structure-grid';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface ProductStructureProps { }

export function ProductStructure(props: ProductStructureProps) {
  const { t } = useTranslation();

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title={t("app.productStructure")} />
            <ProductStructureGrid />
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default ProductStructure;